import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UpdateStorageService {
    public configVersionHasChanged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() { }

}
